module.exports = __webpack_public_path__ + "static/media/icon-dynamic-segment-white.3edc50fb.svg";